export default "__VITE_ASSET__CPaVGEKl__"